import React from 'react';
import { Row, Col, ContentBlock, Skeleton, SkeletonImage } from 'seduo-ui';
const HorizontalCardSkeleton = () => (<ContentBlock className="my-courses">
        <Row className="course-row">
            <Col sm={4} lg={2} className="pr-sm-0">
                <SkeletonImage width="100%" height="78px"/>
            </Col>
            <Col sm={7} className="align-self-stretch">
                <Row className="course-row__main align-items-center">
                    <Col lg={7} className="course-row__info">
                        <div className="mb-6">
                            <Skeleton type="title" standalone={false}/>
                        </div>
                        <div className="course-row__info-subtitle">
                            <Skeleton lines={2}/>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </ContentBlock>);
const Example = () => <HorizontalCardSkeleton />;
export default Example;
